export default {
  styleOverrides: {
    colorDefault: {
      backgroundColor: '#212121',
    },
  },
};
